"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Segment_1 = __importDefault(require("./Segment"));
class SegmentData {
    constructor({ label, device, gender, ageGroup, }) {
        this.toJSON = () => ({
            label: this.label,
            device: this.device,
            gender: this.gender,
            ageGroup: this.ageGroup,
        });
        this.label = label;
        this.device = device;
        this.gender = gender;
        this.ageGroup = ageGroup;
    }
}
SegmentData.fromJSON = (json) => {
    const { label, device, gender, ageGroup } = Object.assign({}, json);
    if (typeof label !== 'string')
        throw new Error('.label must be a string');
    if (!Array.isArray(device))
        throw new Error('.device must be an array');
    if (!Array.isArray(gender))
        throw new Error('.gender must be an array');
    if (!Array.isArray(ageGroup))
        throw new Error('.ageGroup must be an array');
    const _device = device.map(item => Segment_1.default.fromJSON(item));
    const _gender = gender.map(item => Segment_1.default.fromJSON(item));
    const _ageGroup = ageGroup.map(item => Segment_1.default.fromJSON(item));
    return new SegmentData({
        label,
        device: _device,
        gender: _gender,
        ageGroup: _ageGroup,
    });
};
exports.default = SegmentData;
